import { Box, Chip } from "@mui/material";
import CustomText from "../components/CustomText";

const HeaderProyecto = () => {
  return (
    <Box sx={design.heroStyles}>
      <Chip label="El Proyecto" sx={design.Chip} />
      <CustomText
        color="#162E84"
        fontWeight={700}
        fontFamily="Nunito"
        textAlign="left"
        sx={design.Title}
      >
        Un hospital
        <br />
        hecho para
        <br />
        <strong style={design.Color}>cuidar más vidas</strong>
      </CustomText>
      <CustomText
        color="#545454"
        fontWeight={500}
        fontFamily="Nunito"
        textAlign="left"
        sx={design.Descrip}
      >
        Proyecto médico hospitalario de nueve niveles
        <br />
        desarrollado para ofrecer una atención médica integral,
      </CustomText>
    </Box>
  );
};

export default HeaderProyecto;
const design = {
  Title: {
    fontSize: {
      xs: 30,
      sm: 36,
      md: 50,
      lg: 65,
    },
    lineHeight: "normal",
  },
  Descrip: {
    fontSize: {
      xs: 23,
      sm: 36,
      md: 25,
      lg: 25,
    },
    lineHeight: "normal",
    marginTop: "2%",
  },
  Color: { color: "#782A9F" },
  Chip: {
    color: "#FFF",
    background: "#782A9F",
    backdropFilter: "blur(10px)",
    fontFamily: "Nunito",
    fontWeight: 600,
    px: 3,
    fontSize: {
      xs: 14,
      sm: 13,
      md: 15,
      lg: 16,
    },
    mb: 3,
  },
  heroStyles: {
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/HeaderHospitalProyecto.png)`,
    backgroundPosition: "center 30%",
    height: "550px",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    alignItems: "left",
    p: {
      xs: 4,
      sm: 4,
      md: 4,
      lg: 10,
    },
    flexDirection: "column",
  },
};
